import { Dialog, DialogContent } from '@mui/material';
import React, { useEffect } from 'react';
import { MDBox } from '../../../../Component/Common/Components/MDBox';
import { MDTypography } from '../../../../Component/Common/Components/MDTypography';
import { SummaryTable } from '../../../../Component/Common/Components/Table/SummaryTable';
import {
  Gender,
  OccupationalLevelTypes,
  RaceTypes,
  UserActivityActionType,
} from '../../../../Component/Model/Enum/BEE123Enums';
import { MapToEEA4TableData } from '../EEA4_Table';
import { CustomDialogTitle } from '../../../Common/Custom/CustomDialogTitle';
import '../../SummaryTable.css';
import { EEA4Service } from '../../../../Component/Api/Remuneration_EEA4/EEA4Serivce';
import { RemunerationDto } from '../../../../Component/Model/Dto/EmploymentEquity/Remuneration';
import { RemunerationDrillDown } from './RemunerationDrillDown';
import { UserActivityService } from '../../../../Component/Api/UserActivity/UserActivityService';
import { RemunerationSection } from '../../../../Component/Common/Constants/UserActivityTrackingSections';

interface IProps {
  scorecardId: string;
}

export const Remuneration = (props: IProps) => {
  const [totalRemunerationData, setTotalRemunerationData] = React.useState<
    RemunerationDto.SummaryRowDto[]
  >([]);

  const [topRemunerationDetailData, setTopRemunerationDetailData] =
    React.useState<any[]>([]);
  const [bottomRemunerationDetailData, setBottomRemunerationDetailData] =
    React.useState<any[]>([]);
  const [showDrillDown, setShowDrillDown] = React.useState<boolean>(false);
  const [showRemunerationDrillDown, setShowRemunerationDrillDown] =
    React.useState<boolean>(false);
  const [occupationIds, setOccupationIds] = React.useState<number[]>([]);
  const [raceIds, setRaceIds] = React.useState<number[]>([]);
  const [genderIds, setGenderIds] = React.useState<number[]>([]);
  const [isPermanent, setIsPermanent] = React.useState<boolean | null>(true);
  const [totalDrillDown, setTotalDrillDown] = React.useState<boolean>(true);
  const [isHighestRemuneration, setIsHighestRemuneration] = React.useState<
    boolean | null
  >(true);

  const fetchData = async () => {
    try {
      const totalRemunerationSearchResult =
        await EEA4Service.GetTotalRemuneration(props.scorecardId);
      if (totalRemunerationSearchResult.data) {
        setTotalRemunerationData(totalRemunerationSearchResult.data);
      }

      const topRemunerationDetailSearchResult =
        await EEA4Service.GetRemunerationDetail(props.scorecardId, true);
      if (topRemunerationDetailSearchResult.data) {
        setTopRemunerationDetailData(topRemunerationDetailSearchResult.data);
      }

      const bottomRemunerationDetailSearchResult =
        await EEA4Service.GetRemunerationDetail(props.scorecardId, false);
      if (bottomRemunerationDetailSearchResult.data) {
        setBottomRemunerationDetailData(
          bottomRemunerationDetailSearchResult.data
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const buildSearchArraysFromLabel = (label: string) => {
    const tempOccupationIds: number[] = [];
    const tempRaceIds: number[] = [];
    const tempGenderIds: number[] = [];
    label = label.toLowerCase();
    setIsPermanent(true);

    //gender
    if (label.includes('female')) {
      tempGenderIds.push(Gender.Female);
    } else if (label.includes('male')) {
      tempGenderIds.push(Gender.Male);
    } else {
      tempGenderIds.push(Gender.Female);
      tempGenderIds.push(Gender.Male);
    }

    //race
    if (label.includes('nonsa')) {
      tempRaceIds.push(RaceTypes.NonRSA);
    } else if (label.includes('african')) {
      tempRaceIds.push(RaceTypes.African);
    } else if (label.includes('coloured')) {
      tempRaceIds.push(RaceTypes.Coloured);
    } else if (label.includes('indian')) {
      tempRaceIds.push(RaceTypes.Indian);
    } else if (label.includes('white')) {
      tempRaceIds.push(RaceTypes.White);
    } else {
      tempRaceIds.push(RaceTypes.NonRSA);
      tempRaceIds.push(RaceTypes.African);
      tempRaceIds.push(RaceTypes.Coloured);
      tempRaceIds.push(RaceTypes.Indian);
      tempRaceIds.push(RaceTypes.White);
    }

    //occupation
    if (label.includes('top')) {
      tempOccupationIds.push(OccupationalLevelTypes.Executive_Director);
      tempOccupationIds.push(OccupationalLevelTypes.Other_Executive_Management);
    } else if (label.includes('senior')) {
      tempOccupationIds.push(OccupationalLevelTypes.Senior_Management);
    } else if (label.includes('mid')) {
      tempOccupationIds.push(OccupationalLevelTypes.Middle_Management);
    } else if (label.includes('junior')) {
      tempOccupationIds.push(OccupationalLevelTypes.Junior_Management);
    } else if (label.includes('semi-skilled')) {
      tempOccupationIds.push(OccupationalLevelTypes.Semi_Skilled);
    } else if (label.includes('unskilled')) {
      tempOccupationIds.push(OccupationalLevelTypes.Unskilled);
    } else {
      tempOccupationIds.push(OccupationalLevelTypes.Executive_Director);
      tempOccupationIds.push(OccupationalLevelTypes.Other_Executive_Management);
      tempOccupationIds.push(OccupationalLevelTypes.Senior_Management);
      tempOccupationIds.push(OccupationalLevelTypes.Middle_Management);
      tempOccupationIds.push(OccupationalLevelTypes.Junior_Management);
      tempOccupationIds.push(OccupationalLevelTypes.Semi_Skilled);
      tempOccupationIds.push(OccupationalLevelTypes.Unskilled);
    }

    if (label.includes('temporary')) {
      setIsPermanent(false);
    }

    if (label.includes('grand') || !label.includes('|')) {
      setIsPermanent(null);
    }

    setOccupationIds(tempOccupationIds);
    setRaceIds(tempRaceIds);
    setGenderIds(tempGenderIds);

    setShowRemunerationDrillDown(true);
  };

  const onTotalSegmentClick = (label: string) => {
    setTotalDrillDown(true);
    buildSearchArraysFromLabel(label);
  };

  const onTopSegmentClick = (label: string, isHighest: boolean) => {
    setTotalDrillDown(false);
    buildSearchArraysFromLabel(label);
    setIsHighestRemuneration(isHighest);
    setIsPermanent(null);
  };

  useEffect(() => {
    fetchData();
  }, [totalDrillDown]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    UserActivityService.createActivityLog({
      section: RemunerationSection,
      actionType: UserActivityActionType.View,
      actionDescription: 'View remuneration',
      scorecardId: props.scorecardId,
      requestUrl: window.location.href
    });
  }, []);

  const totalRemunerationTableData = MapToEEA4TableData(totalRemunerationData);

  const topRemunerationDetailTableData = MapToEEA4TableData(
    topRemunerationDetailData
  );

  const bottomRemunerationDetailTableData = MapToEEA4TableData(
    bottomRemunerationDetailData
  );

  return (
    <>
      <MDBox>
        <MDBox>
          <MDTypography
            color="info"
            fontWeight="bold"
            style={{ paddingBottom: '10px' }}
          >
            Workforce Profile and Total Remuneration
          </MDTypography>
          <MDTypography
            color="info"
            style={{ paddingBottom: '20px' }}
            fontSize="0.85rem"
          >
            The table below indicates the number of employees, including persons
            with disabilities, and the total remuneration in terms of population
            group and gender for each occupational level. In addition, it also
            indicates the total remuneration per occupational level in your
            organisation.
          </MDTypography>
          {totalRemunerationTableData !== undefined && (
            <SummaryTable
              data={totalRemunerationTableData}
              onSegmentClick={onTotalSegmentClick}
              nestedRows={true}
            ></SummaryTable>
          )}
        </MDBox>

        <MDBox mt={3}>
          <MDTypography
            color="info"
            fontWeight="bold"
            style={{ paddingBottom: '20px' }}
          >
            Fixed / Guaranteed and Variable Remuneration
          </MDTypography>

          <MDTypography
            color="info"
            fontWeight="bold"
            style={{ paddingBottom: '10px', fontSize: '0.85rem' }}
          >
            Highest Total Remuneration
          </MDTypography>

          <MDTypography
            color="info"
            style={{ paddingBottom: '20px' }}
            fontSize="0.85rem"
          >
            The table below shows the remuneration of the employee with the
            highest total remuneration (i.e. fixed/guaranteed and variable
            remuneration) in terms of population group and gender for each
            occupational level, where applicable. Where a choice has to be made
            between two employees with the same total remuneration, i.e. one
            employee having a higher fixed/guaranteed remuneration and the other
            employee having a higher variable remuneration, the employee with
            the higher variable remuneration is chosen.
          </MDTypography>

          {topRemunerationDetailTableData !== undefined && (
            <SummaryTable
              data={topRemunerationDetailTableData}
              onSegmentClick={(label) => onTopSegmentClick(label, true)}
              nestedRows={true}
            ></SummaryTable>
          )}

          <MDTypography
            color="info"
            fontWeight="bold"
            style={{
              paddingTop: '20px',
              paddingBottom: '10px',
              fontSize: '0.85rem',
            }}
          >
            Lowest Total Remuneration
          </MDTypography>

          <MDTypography
            color="info"
            style={{ paddingBottom: '20px' }}
            fontSize="0.85rem"
          >
            The table below shows the remuneration of the employee with the
            lowest total remuneration (i.e., fixed/guaranteed and variable
            remuneration) in terms of population group and gender for each
            occupational level, where applicable. Where a choice has to be made
            between two employees with the same total remuneration, i.e., one
            employee having the lowest fixed/guaranteed remuneration and the
            other employee having the lowest variable remuneration, the employee
            with the lowest variable remuneration is chosen.
          </MDTypography>

          {bottomRemunerationDetailData !== undefined && (
            <SummaryTable
              data={bottomRemunerationDetailTableData}
              onSegmentClick={(label) => onTopSegmentClick(label, false)}
              nestedRows={true}
            ></SummaryTable>
          )}
        </MDBox>
      </MDBox>

      <Dialog
        open={showRemunerationDrillDown}
        onClose={() => setShowRemunerationDrillDown(false)}
        aria-labelledby="form-dialog-title"
        maxWidth="xl"
      >
        <CustomDialogTitle
          id="customized-dialog-title"
          onClose={() => setShowRemunerationDrillDown(false)}
        >
          Employee Remuneration
        </CustomDialogTitle>
        <DialogContent>
          <RemunerationDrillDown
            scorecardId={props.scorecardId}
            occupationIds={occupationIds}
            raceIds={raceIds}
            genderIds={genderIds}
            isPermanent={isPermanent}
            isTotalDrillDown={totalDrillDown}
            isHighestRemuneration={isHighestRemuneration}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};
